import { render, staticRenderFns } from "./ConfigMoved.vue?vue&type=template&id=5798164c"
import script from "./ConfigMoved.vue?vue&type=script&lang=js"
export * from "./ConfigMoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5798164c')) {
      api.createRecord('5798164c', component.options)
    } else {
      api.reload('5798164c', component.options)
    }
    module.hot.accept("./ConfigMoved.vue?vue&type=template&id=5798164c", function () {
      api.rerender('5798164c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/notice/ConfigMoved.vue"
export default component.exports